module.exports = __webpack_public_path__ + "static/media/dot_666666_a.73a89fd7.svg";